import { useEffect, useState } from 'react';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { Auth } from 'aws-amplify';

async function currentUserEmail() {
  return (
    Auth?.user?.attributes?.email ||
    (await Auth.currentAuthenticatedUser()).signInUserSession.idToken.payload
      .email
  );
}

// `undefined` until LD answers (or fails to initialize), then the flag value.
export default function useLaunchDarklyFlag(flagKey) {
  const [value, setValue] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    let ldclient;
    async function init() {
      try {
        const email = await currentUserEmail();
        ldclient = LDClient.initialize(
          process.env.REACT_APP_LAUNCH_DARKLY_CMS || 'nlfaepofjeowiajfpoijewr',
          { key: email },
        );
        ldclient.on('ready', () => {
          if (cancelled) return;
          setValue(ldclient.allFlags()[flagKey]);
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`LD init failed for ${flagKey} flag:`, e);
      }
    }
    init();
    return () => {
      cancelled = true;
      if (ldclient && typeof ldclient.close === 'function') {
        ldclient.close();
      }
    };
  }, [flagKey]);

  return value;
}
